import script from "./DownloadDocumentsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadDocumentsList.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadDocumentsList.vue?vue&type=style&index=0&id=127f2e00&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-127f2e00"]])

export default __exports__